import React from "react";
import Swal from "sweetalert2";
import { useHistory } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form";

// Material-UI
import { Button, Container, Grid, makeStyles,} from "@material-ui/core";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Alert, AlertTitle } from '@material-ui/lab';
// Components
import NavbarUser from "../components/NavbarUser";
import Background from "../components/BackgroundPattern";
import TitlePage from "../components/TitlePageUser";
import TextPilih from "../components/TextPilih";
import Footer from "../components/Footer";
// Data
import DataNilaiKognitif from "../data/DataNilaiKognitif";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  section: {
    margin: theme.spacing(2, 0),
  },
  table: {
    minWidth: 700,
  },
  bgWhite: {
    backgroundColor: "white"
  }
}));

const PilihNilai = ( {classes}) => {
  const { handleSubmit, control } = useForm();
  const history = useHistory();
  const onSubmit = (data) => {
    if (data.pilihNilai === "Kognitif") {
      return history.push('/user/nilai/kognitif')
    } else if (data.pilihNilai === "Afektif") {
      return history.push('/user/nilai/afektif')
    } else {
      return Swal.fire({
        icon: "error",
        title: "Daftar Nilai Tidak Tersedia",
        text: "Silahkan Pilih Daftar Nilai yang lain!",
      });
    }
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={6} sm={6} md={5}>
            <FormControl className={classes.bgWhite} variant="outlined" margin="normal" required fullWidth>
              <InputLabel id="pilihNilaiLabel">{"Pilih Daftar Nilai"}</InputLabel>
              <Controller
                as={
                  <Select
                    labelId="pilihNilaiLabel"
                    id="pilihNilai"
                    label="Pilih Nilai"
                  >
                    <MenuItem value="">
                      <em>{"Pilih Daftar Nilai"}</em>
                    </MenuItem>
                    <MenuItem value="Kognitif">{"Kognitif"}</MenuItem>
                    <MenuItem value="Afektif">{"Afektif"}</MenuItem>
                  </Select>
                }
                name="pilihNilai"
                control={control}
                defaultValue=""
                required
              />
            </FormControl>
          </Grid>
          <Grid item xs={5} sm={4} md={3}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              fullWidth
            >
              {"Pilih"}
            </Button>
          </Grid>
          <Grid item xs={1} sm={2} md={4}></Grid>
        </Grid>
      </form>
    </Container>
  );
};

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const TabelNilai = ({ classes }) => {
  const tableNilai = DataNilaiKognitif.map((data) => (
    <StyledTableRow key={data.id}>
      <StyledTableCell component="th" align="justify">
        {data.id}
      </StyledTableCell>
      <StyledTableCell align="justify">{data.jenisTest}</StyledTableCell>
      <StyledTableCell align="justify">{data.nilaiTest}</StyledTableCell>
    </StyledTableRow>
  ));

  return (
    <Container className={classes.section} maxWidth="md">
      <TableContainer component={Paper} elevation={5}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="justify">{"No"}</StyledTableCell>
              <StyledTableCell align="justify">{"Jenis Test"}</StyledTableCell>
              <StyledTableCell align="justify">{"Nilai"}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableNilai}
            <StyledTableRow>
              <StyledTableCell component="th" align="justify"></StyledTableCell>
              <StyledTableCell align="justify">{"Nilai Akhir"}</StyledTableCell>
              <StyledTableCell align="justify">{"640"}</StyledTableCell>
            </StyledTableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

const NoteNilai = ({classes}) => {
  return(
    <Container className={classes.section} maxWidth="md">
      <Alert severity="warning" variant="outlined" className={classes.bgWhite}>
        <AlertTitle>{"Note : Pretest tidak termasuk kedalam perhitungan nilai akhir"}</AlertTitle>
        {"KKM (75% dari total maksimal nilai akhir sebesar 700) = 525"}
      </Alert>
    </Container>
     
  )
}

const UserNilaiKognitif = () => {
  const classes = useStyles();

  return (
    <section id="user-nilai-kognitif" className={classes.container}>
      <Background/>
      <NavbarUser />
      <Container style={{flex: "1"}}>
        <TitlePage text="Daftar Nilai" />
        <TextPilih text="Pilih Daftar Nilai yang akan ditampilkan"/>
          <PilihNilai classes={classes} />
          <TabelNilai classes={classes}/>
          <NoteNilai classes={classes}/>
      </Container>
      <Footer />
    </section>
  );
};

export default UserNilaiKognitif;
